// ============================================================================
// ATTACHMENT ENDPOINTS - Digital Approval System
// ============================================================================
// Endpoint definitions for Attachment module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for attachment endpoints
 */
const BASE_PATH = '/das/attachments';

/**
 * Attachment Endpoints
 */
export const attachmentEndpoints = {
  /**
   * Upload a file attachment
   * POST /das/attachments/upload
   */
  upload: () => buildEndpoint(`${BASE_PATH}/upload`),

  /**
   * Get attachment by ID
   * GET /das/attachments/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get all attachments for a request
   * GET /das/attachments/request/:requestId
   */
  getByTicketId: (requestId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/request/:requestId`, { requestId }),

  /**
   * Download attachment file
   * GET /das/attachments/:id/download
   */
  download: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/download`, { id }),

  /**
   * Update attachment metadata
   * PUT /das/attachments/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete attachment (soft delete)
   * DELETE /das/attachments/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get attachment statistics for a request
   * GET /das/attachments/request/:requestId/stats
   */
  getStats: (requestId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/request/:requestId/stats`, { requestId }),

  /**
   * Get file upload settings (max size, allowed extensions)
   * GET /das/attachments/settings
   */
  getSettings: () => buildEndpoint(`${BASE_PATH}/settings`),
};
